import * as React from 'react';
import { ActionIcon, Button, createStyles } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

const useStyles = createStyles((theme) => ({
    button: {
        background: '#fff'
    }
}));

interface EditButtonProps {
    minimal?: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick, minimal, disabled }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();

    return minimal ? (
        <ActionIcon color="blue" variant="filled" onClick={onClick} disabled={disabled}>
            <IconEdit size={14} />
        </ActionIcon>
    ) : (
        <Button
            variant="outline"
            onClick={onClick}
            rightIcon={<IconEdit size={14} />}
            disabled={disabled}
            className={classes.button}
        >
            {t('edit', { ns: 'common' })}
        </Button>
    );
};
